<template>

  <keep-alive>
    <router-view @radio="handleRadio"></router-view>
  </keep-alive>
  <MusicPlayer v-show="isFirstPage"/>
</template>
<style >
.modal-backdrop.fade.show {
  display: none !important;
}
</style>
<script>
import MusicPlayer from "./components/MusicPlayer.vue";

export default {
  name: "App",
  data() {
    return {
      playMusic: window.localStorage.getItem('playMusic'),
      isFirstPage: true // Add this state variable
    }
  },
  methods: {
    handleRadio(value) {
      this.playMusic = value;
    },
  },
  watch: {
    $route(to, from) {
      this.isFirstPage = to.path === '/'; // Update this based on your first page route
    }
  },
  components: { 
    MusicPlayer
   },
};
</script>
